import type { JSX } from 'react'

import {
  AtSignIcon,
  MessageSquareIcon,
  ThumbsUpOffIcon,
} from '@buffer-mono/popcorn'

import { SyncSection, SyncSectionText } from '~publish/components/SyncPopover'

export const CommentsSyncSectionIcon = MessageSquareIcon

/**
 * Mentions only ever poll on a fixed schedule, so this section has no states.
 * Render it only for channels that support mentions.
 */
export const MentionsSyncSection = (): JSX.Element => (
  <SyncSection icon={<AtSignIcon size="small" />} label="Mentions">
    <SyncSectionText>Updated every 2 min</SyncSectionText>
  </SyncSection>
)

/**
 * Likes and reactions are not brought into Buffer for any channel yet, so this
 * section states the limitation rather than a sync cadence. `platform` names
 * the network when the popover describes a single channel; without it the copy
 * stays network-agnostic for the all-channels view.
 */
export const LikesSyncSection = ({
  platform,
}: {
  platform?: string
}): JSX.Element => (
  <SyncSection
    icon={<ThumbsUpOffIcon size="small" />}
    label="Likes & reactions"
  >
    <SyncSectionText>
      {platform
        ? `Likes and reactions from ${platform} won't appear in Buffer.`
        : "Likes and reactions won't appear in Buffer."}
    </SyncSectionText>
  </SyncSection>
)
